import React, { useContext, useEffect, useState } from "react";
import api from "../../api";
import AuthContext from "../../context/AuthContext";

export default function CustomerRoleResearch() {
  const { user } = useContext(AuthContext);
  const [papers, setPapers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPaper, setSelectedPaper] = useState(null);
// For Researchers and Sections
const [editResearchers, setEditResearchers] = useState([]);
const [editSections, setEditSections] = useState([]);
const [showPdfMenu, setShowPdfMenu] = useState(null);
const [pdfUrl, setPdfUrl] = useState(null);
const [showPdf, setShowPdf] = useState(null);

  // EDIT STATES
  const [editPaper, setEditPaper] = useState(null);
  const [editTitle, setEditTitle] = useState("");
  const [editAbstract, setEditAbstract] = useState("");
  const [editKeywords, setEditKeywords] = useState("");

  // SAFE JSON PARSER
  const safeParse = (json) => {
    if (!json) return [];
    try {
      return JSON.parse(json);
    } catch (e) {
      return [];
    }
  };
  
const viewContentStyle = {
  overflowWrap: "anywhere",
  wordBreak: "break-word",
  whiteSpace: "pre-wrap",
  maxWidth: "100%",
};

  const fetchMyPapers = async () => {
    try {
      const email = user.username;
      const userType = user.role === "ROLE_ADMIN" ? "ADMIN" : user.customerType;

      const res = await api.get("/api/research-papers/by-user", {
        params: { email, userType },
      });

      setPapers(res.data);
    } catch (err) {
      console.error("Error fetching research papers:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) fetchMyPapers();
  }, [user]);

  // DELETE FUNCTION
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this research paper?")) return;

    try {
      const email = user.username;
      const userType = user.role === "ROLE_ADMIN" ? "ADMIN" : user.customerType;

      await api.delete(`/api/research-papers/delete-my-paper/${id}`, {
        params: { email, userType },
      });

      alert("Research Paper deleted successfully!");
      fetchMyPapers();
    } catch (err) {
      console.error("Delete error:", err);
      alert("Failed to delete research paper");
    }
  };
  const stripHtml = (html = "") => {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
};
const htmlToPlainText = (html = "") => {
  if (!html) return "";

  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
};

const stripAdminHighlightHtml = (html = "") => {
  if (!html) return html;

  return html
    // remove color spans
    .replace(/<span[^>]*style=["']?[^"'>]*color\s*:\s*red[^"'>]*["']?[^>]*>/gi, "")
    .replace(/<\/span>/gi, "")
    // remove strong tags
    .replace(/<\/?strong>/gi, "")
    // cleanup empty tags
    .replace(/<p>\s*<\/p>/gi, "")
    .trim();
};

const acceptSection = (index) => {
  setEditSections(prev =>
    prev.map((sec, i) =>
      i === index
        ? {
            ...sec,
            content: htmlToPlainText(
  stripAdminHighlightHtml(sec.suggestedContent)
),
            suggestedContent: null,
            suggested: false,
            reviewStatus: "ACCEPTED",
          }
        : sec
    )
  ); 
};

const rejectSection = (index) => {
  setEditSections(prev =>
    prev.map((sec, i) =>
      i === index
        ? {
            ...sec,
            suggestedContent: null, // 🔥 drop admin text
            suggested: false,
            reviewStatus: "REJECTED",
          }
        : sec
    )
  );
};

const parseAdminNotes = (notes) => {
  if (!notes || notes === "{}") return {};
  try {
    const parsed = JSON.parse(notes);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
};
const openPdf = async (type, paperId) => {
  try {
    const res = await api.get(
      `/api/research-papers/pdf/${paperId}/${type}`,
      { responseType: "blob" }
    );

    const blob = new Blob([res.data], {
      type: "application/pdf",
    });

    const blobUrl = URL.createObjectURL(blob);
    setPdfUrl(blobUrl);
    setShowPdf(type);

  } catch (e) {
    console.error(e);
    alert("Unable to open PDF");
  }
};


  // OPEN EDIT MODAL
const openEditModal = (paper) => {
  setEditPaper(paper);
  setEditTitle(paper.title);
  setEditKeywords(paper.keywords);

  // ✅ ABSTRACT — PLAIN TEXT ONLY
  if (paper.suggestedAbstractText) {
    setEditAbstract(stripHtml(paper.abstractText));
  } else {
    setEditAbstract(stripHtml(paper.abstractText));
  }

  setEditResearchers(
    safeParse(paper.suggestedResearchersJson || paper.researchersJson)
  );


 const originalSections = safeParse(paper.sectionsJson);
const suggestedSections = safeParse(paper.suggestedSectionsJson);

// 🔥 map suggested sections by heading
const suggestedMap = {};
suggestedSections.forEach(s => {
  suggestedMap[s.heading] = s;
});

setEditSections(
  originalSections.map(sec => {
    const suggestion = suggestedMap[sec.heading];

    return {
      ...sec,
      content: stripHtml(sec.content),

      suggestedContent: suggestion?.suggestedContent || null,
      suggested: !!suggestion,
      reviewStatus: suggestion?.reviewStatus || "NONE",
    };
  })
);

};

const admitAdminNotes = async () => {
  if (!editPaper) return;

  try {
    await api.put(
      `/api/research-papers/customer/admit-notes/${editPaper.id}`
    );

    // 🔥 remove notes from current view
    setEditPaper(prev => ({
      ...prev,
      adminNotes: null,
    }));

    fetchMyPapers(); // optional refresh

  } catch (err) {
    console.error("Admit notes error:", err);
    alert("Failed to admit admin notes");
  }
};
  // SAVE EDITED PAPER
  const handleSaveEdit = async () => {
    const cleanedSections = editSections.map(
  ({ heading, content }) => ({
    heading,
   content: stripAdminHighlightHtml(content),
  })
);
    try {
      const email = user.username;
      const userType = user.role === "ROLE_ADMIN" ? "ADMIN" : user.customerType;

   await api.put(
  `/api/research-papers/update-my-paper/${editPaper.id}`,
  {
    title: editTitle,
    abstractText: editAbstract,
    keywords: editKeywords,
    researchersJson: JSON.stringify(editResearchers),
   sectionsJson: JSON.stringify(cleanedSections),
  },
  {
    params: { email, userType },
  }
);
      alert("Research updated successfully!");
      setEditPaper(null);
      fetchMyPapers();
    } catch (err) {
      console.error("Update error:", err);
      alert("Failed to update research paper");
    }
  };

  if (loading)
    return <h3 className="text-center mt-5">Loading research papers...</h3>;
const adminNotesMap = editPaper
  ? parseAdminNotes(editPaper.adminNotes)
  : {};

const styles = {
  paperContent: {
    overflowWrap: "anywhere",
    wordBreak: "break-word",
  },

  adminAdded: {
    display: "inline-block",
    backgroundColor: "#ffe0e0",
    color: "red",
    fontWeight: "bold",
    padding: "4px 6px",
    borderLeft: "4px solid red",
    marginTop: "6px",
    maxWidth: "100%",
    overflowWrap: "anywhere",
    wordBreak: "break-word",
  },
};
const extractAdminDelta = (original = "", suggested = "") => {
  if (!suggested.startsWith(original)) return suggested;
  return suggested.slice(original.length);
};

  return (
    <div className="container my-4">
    {showPdf && pdfUrl && (
  <div
    className="modal fade show"
    style={{ display: "block", background: "rgba(0,0,0,0.6)" }}
  >
    <div className="modal-dialog modal-xl modal-dialog-centered">
      <div className="modal-content">

        <div className="modal-header">
          <h5 className="modal-title">
            {showPdf.replace("_", " ")}
          </h5>
          <button
            className="btn-close"
            onClick={() => {
              URL.revokeObjectURL(pdfUrl);
              setPdfUrl(null);
              setShowPdf(null);
            }}
          />
        </div>

        <div className="modal-body" style={{ height: "80vh" }}>
          <iframe
            src={pdfUrl}
            width="100%"
            height="100%"
            style={{ border: "none" }}
            title="PDF Viewer"
          />
        </div>

      </div>
    </div>
  </div>
)}
      <h3 className="fw-bold text-primary mb-4">
        📄 Your Research Papers ({user.customerType})
      </h3>

      {/* LIST */}
      <div className="row g-4">
        {papers.length > 0 ? (
          papers.map((p) => (
            <div key={p.id} className="col-md-6">
              <div className="card shadow-sm p-3 rounded-4">

                <h5 className="fw-semibold">{p.title}</h5>

                <p className="badge bg-info text-dark px-3 py-2">Status: {p.status}</p>

                <p><b>Researchers:</b> {safeParse(p.researchersJson).length}</p>
                <p><b>Sections:</b> {safeParse(p.sectionsJson).length}</p>

                <div className="d-flex gap-2 mt-2">

                  {/* VIEW */}
                  <button
                    className="btn btn-outline-primary btn-sm rounded-pill"
                    data-bs-toggle="modal"
                    data-bs-target="#paperModal"
                    onClick={() => setSelectedPaper(p)}
                  >
                    👁 View
                  </button>

                  {/* EDIT */}
                  <button
                    className="btn btn-warning btn-sm rounded-pill"
                    onClick={() => openEditModal(p)}
                  >
                    ✏ Edit
                  </button>

                  {/* DELETE */}
                  <button
                    className="btn btn-danger btn-sm rounded-pill"
                    onClick={() => handleDelete(p.id)}
                  >
                    🗑 Delete
                  </button>


{/* 🔽 Animated PDF menu */}

{/* 📄 PDF DROPDOWN */}
<div className="dropdown">
  <button
    className="btn btn-outline-primary btn-sm dropdown-toggle"
    type="button"
    onClick={() =>
      setShowPdfMenu(prev => (prev === p.id ? null : p.id))
    }
  >
    📄 PDFs
  </button>

  {showPdfMenu === p.id && (
    <ul className="dropdown-menu show shadow rounded-3 mt-2">

      <li>
        <button className="dropdown-item" onClick={() => openPdf("NOC", p.id)}>
          📄 NOC
        </button>
      </li>

      <li>
        <button className="dropdown-item" onClick={() => openPdf("IEC_CLEARANCE", p.id)}>
          📄 IEC Clearance
        </button>
      </li>

      <li>
        <button className="dropdown-item" onClick={() => openPdf("UNIVERSITY_APPROVAL", p.id)}>
          📄 University Approval
        </button>
      </li>

      <li>
        <button className="dropdown-item" onClick={() => openPdf("FINAL_RESULTS", p.id)}>
          📄 Final Results
        </button>
      </li>

      <li>
        <button className="dropdown-item" onClick={() => openPdf("LICENSING_AGREEMENT", p.id)}>
          📄 Licensing Agreement
        </button>
      </li>

    </ul>
  )}
</div>

<style>
{`
.pdf-menu {
  margin-top: 6px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.pdf-menu button {
  border: 1px solid #0d6efd;
  background: white;
  color: #0d6efd;
  padding: 6px 10px;
  border-radius: 5px;
  font-size: 13px;
  text-align: left;
}

.pdf-menu button:hover {
  background: #0d6efd;
  color: white;
}
`}
</style>


                </div>
              </div>
            </div>
          ))
        ) : (
          <p className="text-center text-muted">No research papers found.</p>
        )}
      </div>

      {/* VIEW MODAL */}
      <div className="modal fade" id="paperModal" tabIndex="-1">
        <div className="modal-dialog modal-xl modal-dialog-centered">
          <div className="modal-content rounded-4 shadow-lg">
{selectedPaper && (
  <>
    <div className="modal-header bg-primary text-white">
      <h5 className="modal-title">{selectedPaper.title}</h5>
      <button
        className="btn-close btn-close-white"
        data-bs-dismiss="modal"
      ></button>
    </div>

    <div
      className="modal-body"
      style={{ maxHeight: "75vh", overflowY: "auto" }}
    >
      <h5>Abstract</h5>
     <div
  style={viewContentStyle}
  dangerouslySetInnerHTML={{ __html: selectedPaper.abstractText }}
/>


      {/* 📝 ADMIN NOTE FOR ABSTRACT */}
    

      <h5 className="mt-4">Keywords</h5>
      <p>{selectedPaper.keywords}</p>

      <h5 className="mt-4">Researchers</h5>
      {safeParse(selectedPaper.researchersJson).map((r, i) => (
        <p key={i}>
          <b>{r.name}</b> — {r.qualification}
        </p>
      ))}
      <h5 className="mt-4">Sections</h5>
      {safeParse(selectedPaper.sectionsJson).map((s, i) => (
        <div key={i} className="my-3">
          <h6 className="fw-bold">{s.heading}</h6>
<div
  style={viewContentStyle}
  dangerouslySetInnerHTML={{ __html: s.content }}
/>
          {/* 📝 ADMIN NOTE FOR SECTION */}
         
        </div>
      ))}

      {/* 🟢 ADMIT CHANGES BUTTON */}
     
    </div>
  </>
)}
          </div>
        </div>
      </div>

      {/* EDIT MODAL */}
  {
  editPaper && (
  <div className="modal fade show" style={{ display: "block", background: "#0006" }}>
    <div className="modal-dialog modal-xl modal-dialog-centered">
      <div className="modal-content rounded-4">

        {/* HEADER */}
        <div className="modal-header bg-warning">
          <h5>Edit Entire Research Paper</h5>
          <button className="btn-close" onClick={() => setEditPaper(null)} />
        </div>

        {/* BODY */}
        <div className="modal-body" style={{ maxHeight: "75vh", overflowY: "auto" }}>

          {/* TITLE */}
          <label className="fw-bold">Title</label>
          <input
            className="form-control mb-3"
            value={editTitle}
            onChange={(e) => setEditTitle(e.target.value)}
          />

          {/* ABSTRACT */}
      {/* ABSTRACT */}
<label className="fw-bold">Abstract</label>

{/* ✅ CUSTOMER EDITABLE ABSTRACT */}
<textarea
  className="form-control mb-2"
  rows={4}
  value={editAbstract}
  onChange={(e) => setEditAbstract(e.target.value)}
  style={{
    overflowWrap: "anywhere",
    wordBreak: "break-word",
  }}
/>
{adminNotesMap.abstract && (
  <div
    style={{
      backgroundColor: "#fff3cd",
      borderLeft: "4px solid #ffc107",
      padding: "10px",
      marginTop: "8px",
    }}
  >
    <strong>Admin Note (Abstract):</strong>
    <p className="mb-2">{adminNotesMap.abstract}</p>

  </div>
)}

{/* ✅ ADMIN-ADDED PART (HIGHLIGHTED ONLY) */}
{editPaper.suggestedAbstractText && (() => {
  const adminDelta = extractAdminDelta(
    editPaper.abstractText,
    editPaper.suggestedAbstractText
  );

  return adminDelta ? (
    <div
      style={{
        backgroundColor: "#ffe0e0",
        color: "red",
        fontWeight: "bold",
        padding: "8px",
        borderLeft: "4px solid red",
        marginTop: "6px",
        overflowWrap: "anywhere",
        wordBreak: "break-word",
      }}
    >
      <span dangerouslySetInnerHTML={{ __html: adminDelta }} />

      <div className="mt-2 d-flex gap-2">
        <button
          className="btn btn-success btn-sm"
          onClick={() => {
            setEditAbstract(editPaper.suggestedAbstractText);

            setEditPaper(prev => ({
              ...prev,
              abstractText: prev.suggestedAbstractText,
              suggestedAbstractText: null,
            }));
          }}
        >
          ✅ Accept
        </button>

        <button
          className="btn btn-danger btn-sm"
          onClick={() =>
            setEditPaper(prev => ({
              ...prev,
              suggestedAbstractText: null,
            }))
          }
        >
          ❌ Reject
        </button>
      </div>
    </div>
  ) : null;
})()}

          {/* KEYWORDS */}
          <label className="fw-bold mt-3">Keywords</label>
          <input
            className="form-control mb-4"
            value={editKeywords}
            onChange={(e) => setEditKeywords(e.target.value)}
          />

          {/* SECTIONS */}
          <h5>Sections</h5>

{editSections.map((s, index) => (
  <div key={index} className="border rounded p-3 mb-4">

    <h6 className="fw-bold">{s.heading}</h6>

    {/* ✅ ORIGINAL CUSTOMER CONTENT */}
   <textarea
  className="form-control mb-2"
  rows={4}
  value={s.content}
  onChange={(e) => {
    const updated = [...editSections];
    updated[index].content = e.target.value;
    setEditSections(updated);
  }}
/>
{adminNotesMap[s.heading] && (
  <div
    style={{
      backgroundColor: "#fff3cd",
      borderLeft: "4px solid #ffc107",
      padding: "10px",
      marginTop: "8px",
    }}
  >
    <strong>Admin Note:</strong>
    <p className="mb-2">{adminNotesMap[s.heading]}</p>

  
  </div>
)}

{ s.suggested && s.reviewStatus === "PENDING" && s.suggestedContent && (() => {
  const adminDelta = extractAdminDelta(s.content, s.suggestedContent);
  return adminDelta ? (
    <div style={styles.adminAdded}>
      <strong>Admin added:</strong>
      <div dangerouslySetInnerHTML={{ __html: adminDelta }} />

      <div className="mt-2 d-flex gap-2">
        <button
          className="btn btn-success btn-sm"
          onClick={() => acceptSection(index)}
        >
          ✅ Accept Changes
        </button>

        <button
          className="btn btn-danger btn-sm"
          onClick={() => rejectSection(index)}
        >
          ❌ Reject Changes
        </button>
      </div>
    </div>
  ) : null;
})()}
  </div>
))}
        </div>
       {/* FOOTER (ONLY ONE!) */}
        <div className="modal-footer">
          <button
            className="btn btn-success"
            onClick={handleSaveEdit}
          >
            💾 Save All Changes
          </button>
            <button
      className="btn btn-success btn-sm"
      onClick={admitAdminNotes}
    >
      ✅ Admit Changes
    </button>
          <button
            className="btn btn-secondary"
            onClick={() => setEditPaper(null)}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
)}
    </div>
  );
}
